import { setElementHtml } from './set-element-html.js'

/**
 * Usage:
 * import { showLoading } from '@local_modules/generic/dom/show-loading.js'
 *
 * @param {String} elementId
 * @returns {Element|null} DOM Element or null
 */
export function showLoading (elementId) {
  const loadingElementHtml = '<progress class="progress is-small is-info" max="100">Loading</progress>'
  const element = setElementHtml(elementId, loadingElementHtml)
  return element
}
